var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _g2, _path14, _path15, _g3, _path16, _path17, _g4, _path18, _path19, _g5, _path20, _path21, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 57,
    viewBox: "0 0 270 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2051 49.3436V12.3525H26.8771V49.3436H20.2051Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8031 12.4046V49.3956L68.1312 44.3225L44.1134 25.9863V49.3956H37.4414V12.5102L44.1134 17.5833L68.1312 35.9211V12.3525L74.8031 12.4046Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.685 22.6044V22.3931C108.685 20.5442 107.138 19.0112 105.269 19.0112H90.1116C88.2442 19.0112 86.6959 20.5442 86.6959 22.3931V22.6044C86.6959 24.4533 88.2442 25.9863 90.1116 25.9863H103.561C107.031 25.9863 110.126 27.4656 112.262 29.7914C112.421 29.9491 112.529 30.1073 112.688 30.2666C114.343 32.2748 115.357 34.8645 115.357 37.6638C115.357 44.1122 110.073 49.343 103.562 49.343H91.8728C85.3617 49.343 80.0787 44.1122 80.0787 37.6638H86.7507C86.7507 40.4648 89.0454 42.7369 91.8728 42.7369H103.562C106.391 42.7369 108.74 40.4648 108.74 37.6638C108.74 34.8629 106.391 32.5907 103.562 32.5907H90.1121C87.3899 32.5907 84.9359 31.5346 83.121 29.7914C82.6394 29.3145 82.2136 28.7873 81.8388 28.2064C80.719 26.6198 80.0781 24.6646 80.0781 22.5508V22.3394C80.0781 16.8447 84.561 12.3525 90.1121 12.3525H105.27C110.821 12.3525 115.358 16.8447 115.358 22.3394V22.5508L108.686 22.6044H108.685Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.199 30.848C154.199 37.4005 159.59 42.7375 166.207 42.7375H178.217V35.6572H166.207V29.0512H184.889V49.3436H166.207C155.907 49.3436 147.527 41.0463 147.527 30.848C147.527 20.6498 155.907 12.3525 166.207 12.3525H184.889V18.957H166.207C159.59 18.957 154.199 24.2951 154.199 30.848Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.471 12.3525V49.3436H220.799V32.381H196.781V49.3436H190.109V12.3525H196.781V25.7749H220.799V12.3525H227.471Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M270.001 12.4048V19.0109H254.684V49.3958H248.012V19.0109H232.693V12.4048H270.001Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0175781 38.1323H2.04908V42.7495H11.3907V44.7593H2.04854V49.3765H0.0175781V38.1323Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.2407H11.3732V27.2505H6.15843V34.4901H11.3732V36.4999H0V34.4901H4.12747V27.2505H0V25.2407Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07109 21.6141H4.12747V14.3745H6.15789V21.6141H8.30207C8.87089 21.6141 9.34165 21.1479 9.34165 20.5847V12.3652H11.3721V20.5847C11.3721 22.2577 9.99119 23.6094 8.30153 23.6094H3.07109C1.38142 23.6094 0 22.2583 0 20.5847V12.3652H2.0315V20.5847C2.0315 21.1479 2.50227 21.6141 3.07109 21.6141Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.507 0C127.161 0 125.26 1.8827 125.26 4.20577C125.26 6.52884 129.507 11.6191 129.507 11.6191C129.507 11.6191 133.755 6.5283 133.755 4.20577C133.755 1.88324 131.853 0 129.507 0ZM129.535 5.51293C128.857 5.52795 128.296 4.99639 128.281 4.32592C128.266 3.6549 128.803 3.09921 129.48 3.08419C130.158 3.06917 130.719 3.60073 130.734 4.27121C130.749 4.94222 130.212 5.49791 129.535 5.51239V5.51293Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_512_1104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 125,
    y: 0,
    width: 9,
    height: 12
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.507 0C127.161 0 125.26 1.8827 125.26 4.20577C125.26 6.52884 129.507 11.6191 129.507 11.6191C129.507 11.6191 133.755 6.5283 133.755 4.20577C133.755 1.88324 131.853 0 129.507 0ZM129.535 5.51293C128.857 5.52795 128.296 4.99639 128.281 4.32592C128.266 3.6549 128.803 3.09921 129.48 3.08419C130.158 3.06917 130.719 3.60073 130.734 4.27121C130.749 4.94222 130.212 5.49791 129.535 5.51239V5.51293Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_512_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.699 5.52854L130.749 5.47168V5.52854H130.699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.592 5.52832L130.749 5.34863V5.47146L130.7 5.52832H130.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.484 5.52859L130.75 5.22607V5.34891L130.592 5.52859H130.484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.375 5.52838L130.748 5.10303V5.22586L130.483 5.52838H130.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.268 5.52865L130.749 4.98047V5.1033L130.375 5.52865H130.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.16 5.52844L130.749 4.85742V4.98025L130.268 5.52844H130.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.053 5.52871L130.749 4.73486V4.85769L130.161 5.52871H130.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.945 5.52849L130.749 4.61182V4.73465L130.053 5.52849H129.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.838 5.52828L130.75 4.48877V4.6116L129.946 5.52828H129.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.73 5.52855L130.75 4.36621V4.48904L129.838 5.52855H129.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.621 5.52833L130.748 4.24316V4.366L129.729 5.52833H129.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.514 5.52861L130.749 4.12061V4.24344L129.621 5.52861H129.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.406 5.52839L130.749 3.99756V4.12039L129.514 5.52839H129.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.299 5.52866L130.75 3.875V3.99783L129.407 5.52866H129.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.191 5.52845L130.75 3.75195V3.87478L129.299 5.52845H129.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.082 5.52872L130.748 3.62939V3.75223L129.19 5.52872H129.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.975 5.52851L130.749 3.50635V3.62918L129.082 5.52851H128.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.867 5.52829L130.749 3.3833V3.50613L128.974 5.52829H128.867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.76 5.52856L130.749 3.26074V3.38357L128.868 5.52856H128.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.652 5.52835L130.749 3.1377V3.26053L128.76 5.52835H128.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.545 5.52865L130.702 3.06934H130.75V3.13799L128.653 5.52865H128.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.436 5.52865L130.593 3.06934H130.701L128.543 5.52865H128.436Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.328 5.52865L130.486 3.06934H130.593L128.436 5.52865H128.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 5.47769L130.378 3.06934H130.486L128.328 5.52865H128.266V5.47769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 5.35486L130.271 3.06934H130.378L128.266 5.47769V5.35486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 5.23203L130.163 3.06934H130.271L128.266 5.35486V5.23203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 5.10919L130.055 3.06934H130.163L128.266 5.23203V5.10919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 4.98636L129.947 3.06934H130.055L128.266 5.10919V4.98636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 4.86353L129.839 3.06934H129.947L128.266 4.98636V4.86353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 4.7407L129.732 3.06934H129.839L128.266 4.86353V4.7407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 4.61787L129.624 3.06934H129.732L128.266 4.7407V4.61787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 4.49504L129.516 3.06934H129.624L128.266 4.61787V4.49504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 4.37221L129.408 3.06934H129.516L128.266 4.49504V4.37221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 4.24938L129.301 3.06934H129.408L128.266 4.37221V4.24938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 4.12654L129.193 3.06934H129.301L128.266 4.24938V4.12654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 4.00371L129.085 3.06934H129.193L128.266 4.12654V4.00371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 3.88088L128.977 3.06934H129.085L128.266 4.00371V3.88088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 3.75805L128.87 3.06934H128.977L128.266 3.88088V3.75805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 3.63522L128.762 3.06934H128.87L128.266 3.75805V3.63522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 3.51239L128.654 3.06934H128.762L128.266 3.63522V3.51239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 3.38956L128.546 3.06934H128.654L128.266 3.51239V3.38956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 3.26672L128.438 3.06934H128.546L128.266 3.38956V3.26672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.266 3.14389L128.331 3.06934H128.438L128.266 3.26672V3.14389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.331 3.06934L128.266 3.14389V3.06934H128.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.941 11.6191L133.754 4.99316V11.6191H127.941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.834 11.6189L133.755 4.87012V4.99295L127.942 11.6189H127.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.727 11.6191L133.755 4.74756V4.87039L127.834 11.6191H127.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.619 11.6189L133.755 4.62451V4.74734L127.727 11.6189H127.619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.51 11.6192L133.754 4.50195V4.62478L127.618 11.6192H127.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.402 11.619L133.754 4.37891V4.50174L127.51 11.619H127.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.295 11.6193L133.755 4.25635V4.37918L127.403 11.6193H127.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.188 11.619L133.755 4.1333V4.25613L127.295 11.619H127.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.08 11.6193L133.755 4.01074V4.13357L127.188 11.6193H127.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.971 11.6191L133.754 3.8877V4.01053L127.079 11.6191H126.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.865 11.6189L133.756 3.76465V3.88748L126.972 11.6189H126.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.756 11.6192L133.754 3.64209V3.76492L126.864 11.6192H126.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.648 11.6189L133.754 3.51904V3.64187L126.756 11.6189H126.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.541 11.6192L133.755 3.39648V3.51932L126.649 11.6192H126.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.434 11.619L133.755 3.27344V3.39627L126.541 11.619H126.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.326 11.6193L133.756 3.15088V3.27371L126.434 11.6193H126.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.217 11.619L133.754 3.02832V3.15062L126.325 11.619H126.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.109 11.6193L133.754 2.90576V3.02859L126.217 11.6193H126.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.002 11.6191L133.755 2.78271V2.90555L126.11 11.6191H126.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.895 11.6193L133.755 2.66016V2.78299L126.002 11.6193H125.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.787 11.6191L133.755 2.53711V2.65994L125.895 11.6191H125.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.68 11.6189L133.755 2.41406V2.53689L125.787 11.6189H125.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.57 11.6192L133.754 2.2915V2.41434L125.678 11.6192H125.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.463 11.619L133.754 2.16846V2.29129L125.571 11.619H125.463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.355 11.6192L133.755 2.0459V2.16873L125.463 11.6192H125.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 11.6051L133.755 1.92285V2.04568L125.356 11.619H125.26V11.6051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 11.4825L133.755 1.80029V1.92312L125.26 11.6053V11.4825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 11.3595L133.755 1.67725V1.80008L125.26 11.4823V11.3595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 11.2364L133.755 1.5542V1.67703L125.26 11.3593V11.2364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 11.1139L133.755 1.43164V1.55447L125.26 11.2367V11.1139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 10.9908L133.755 1.30859V1.43143L125.26 11.1136V10.9908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 10.8683L133.755 1.18604V1.30887L125.26 10.9911V10.8683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 10.7452L133.755 1.06299V1.18582L125.26 10.868V10.7452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 10.6227L133.755 0.94043V1.06326L125.26 10.7455V10.6227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 10.4996L133.755 0.817383V0.940214L125.26 10.6224V10.4996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 10.377L133.755 0.694824V0.817656L125.26 10.4999V10.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 10.254L133.755 0.571777V0.694609L125.26 10.3768V10.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 10.1315L133.755 0.44873V0.571562L125.26 10.2538V10.1315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 10.0089L133.755 0.326172V0.449003L125.26 10.1318V10.0089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 9.88588L133.755 0.203125V0.325956L125.26 10.0087V9.88588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 9.76333L133.755 0.0805664V0.203398L125.26 9.88616V9.76333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 9.64038L133.718 0H133.755V0.0804572L125.26 9.76322V9.64038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 9.51755L133.61 0H133.718L125.26 9.64038V9.51755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 9.39472L133.502 0H133.61L125.26 9.51755V9.39472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 9.27189L133.394 0H133.502L125.26 9.39472V9.27189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 9.14906L133.287 0H133.394L125.26 9.27189V9.14906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 9.02623L133.179 0H133.287L125.26 9.14906V9.02623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 8.9034L133.071 0H133.179L125.26 9.02623V8.9034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 8.78057L132.963 0H133.071L125.26 8.9034V8.78057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 8.65773L132.855 0H132.963L125.26 8.78056V8.65773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 8.5349L132.748 0H132.855L125.26 8.65773V8.5349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 8.41207L132.64 0H132.748L125.26 8.5349V8.41207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 8.28924L132.533 0H132.64L125.26 8.41207V8.28924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 8.16641L132.425 0H132.533L125.26 8.28924V8.16641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 8.04358L132.317 0H132.425L125.26 8.16641V8.04358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 7.92075L132.209 0H132.317L125.26 8.04358V7.92075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 7.79791L132.101 0H132.209L125.26 7.92075V7.79791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 7.67508L131.994 0H132.101L125.26 7.79791V7.67508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 7.55225L131.886 0H131.994L125.26 7.67508V7.55225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 7.42942L131.778 0H131.886L125.26 7.55225V7.42942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 7.30659L131.67 0H131.778L125.26 7.42942V7.30659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 7.18376L131.563 0H131.67L125.26 7.30659V7.18376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 7.06093L131.455 0H131.563L125.26 7.18376V7.06093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 6.9381L131.347 0H131.455L125.26 7.06093V6.9381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 6.81526L131.239 0H131.347L125.26 6.9381V6.81526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 6.69243L131.132 0H131.239L125.26 6.81526V6.69243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 6.5696L131.024 0H131.132L125.26 6.69243V6.5696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 6.44677L130.916 0H131.024L125.26 6.5696V6.44677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 6.32394L130.808 0H130.916L125.26 6.44677V6.32394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 6.20111L130.7 0H130.808L125.26 6.32394V6.20111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 6.07828L130.593 0H130.7L125.26 6.20111V6.07828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 5.95544L130.485 0H130.593L125.26 6.07827V5.95544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 5.83261L130.378 0H130.485L125.26 5.95544V5.83261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 5.70978L130.27 0H130.378L125.26 5.83261V5.70978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 5.58749L130.162 0H130.27L125.26 5.70978V5.58749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 5.46465L130.054 0H130.162L125.26 5.58749V5.46465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 5.34182L129.946 0H130.054L125.26 5.46465V5.34182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 5.21899L129.838 0H129.946L125.26 5.34182V5.21899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 5.09616L129.731 0H129.838L125.26 5.21899V5.09616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 4.97333L129.623 0H129.731L125.26 5.09616V4.97333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 4.8505L129.515 0H129.623L125.26 4.97333V4.8505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 4.72767L129.407 0H129.515L125.26 4.8505V4.72767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 4.60484L129.3 0H129.407L125.26 4.72767V4.60484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 4.482L129.192 0H129.3L125.26 4.60484V4.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 4.35917L129.084 0H129.192L125.26 4.482V4.35917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 4.23634L128.977 0H129.084L125.26 4.35917V4.23634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 4.11351L128.869 0H128.977L125.26 4.23634V4.11351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 3.99068L128.761 0H128.869L125.26 4.11351V3.99068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 3.86785L128.653 0H128.761L125.26 3.99068V3.86785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 3.74502L128.545 0H128.653L125.26 3.86785V3.74502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 3.62218L128.438 0H128.545L125.26 3.74502V3.62218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 3.49935L128.33 0H128.438L125.26 3.62218V3.49935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26 3.37652L128.222 0H128.33L125.26 3.49935V3.37652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.222 0L125.26 3.37652V0H128.222Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.564 38.1953L139.587 38.4056C139.778 40.2448 138.397 41.9275 136.54 42.1174L135.977 42.1747L133.512 18.5589L137.123 18.1894L136.437 11.6182L129.777 14.9099L133.351 49.1375L137.232 48.7401C142.753 48.1747 146.746 43.2502 146.175 37.785L146.153 37.5747L139.564 38.1953Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_512_1104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 129,
    y: 11,
    width: 18,
    height: 39
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M139.564 38.1953L139.587 38.4056C139.778 40.2448 138.397 41.9275 136.54 42.1174L135.977 42.1747L133.512 18.5589L137.123 18.1894L136.437 11.6182L129.777 14.9099L133.351 49.1375L137.232 48.7401C142.753 48.1747 146.746 43.2502 146.175 37.785L146.153 37.5747L139.564 38.1953Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_512_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.777 14.9106L133.351 49.1382H129.777V14.9106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.777 13.4521L133.503 49.1381H133.351L129.777 14.9106V13.4521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.777 11.9932L133.655 49.1381H133.503L129.777 13.4521V11.9932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.891 11.6191L133.807 49.138H133.655L129.777 11.993V11.6191H129.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.043 11.6191L133.96 49.138H133.807L129.891 11.6191H130.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.195 11.6191L134.112 49.138H133.96L130.043 11.6191H130.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.348 11.6191L134.264 49.138H134.112L130.195 11.6191H130.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5 11.6191L134.417 49.138H134.264L130.348 11.6191H130.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.652 11.6191L134.569 49.138H134.417L130.5 11.6191H130.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.805 11.6191L134.722 49.138H134.569L130.652 11.6191H130.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.957 11.6191L134.874 49.138H134.721L130.805 11.6191H130.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.109 11.6191L135.026 49.138H134.874L130.957 11.6191H131.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.262 11.6191L135.178 49.138H135.026L131.109 11.6191H131.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.414 11.6191L135.331 49.138H135.178L131.262 11.6191H131.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.566 11.6191L135.483 49.138H135.331L131.414 11.6191H131.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.719 11.6191L135.635 49.138H135.483L131.566 11.6191H131.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.871 11.6191L135.788 49.138H135.635L131.719 11.6191H131.871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.021 11.6191L135.938 49.138H135.786L131.869 11.6191H132.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.174 11.6191L136.09 49.138H135.938L132.021 11.6191H132.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.327 11.6191L136.243 49.138H136.091L132.174 11.6191H132.327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.48 11.6191L136.397 49.138H136.245L132.328 11.6191H132.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.631 11.6191L136.547 49.138H136.395L132.479 11.6191H132.631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.783 11.6191L136.7 49.138H136.548L132.631 11.6191H132.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.935 11.6191L136.852 49.138H136.7L132.783 11.6191H132.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.088 11.6191L137.005 49.138H136.852L132.936 11.6191H133.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.24 11.6191L137.157 49.138H137.005L133.088 11.6191H133.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.392 11.6191L137.309 49.138H137.157L133.24 11.6191H133.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.545 11.6191L137.462 49.138H137.309L133.393 11.6191H133.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.697 11.6191L137.614 49.138H137.462L133.545 11.6191H133.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.85 11.6191L137.767 49.138H137.614L133.697 11.6191H133.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.002 11.6191L137.919 49.138H137.766L133.85 11.6191H134.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.154 11.6191L138.071 49.138H137.919L134.002 11.6191H134.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.307 11.6191L138.223 49.138H138.071L134.154 11.6191H134.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.459 11.6191L138.376 49.138H138.223L134.307 11.6191H134.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.611 11.6191L138.528 49.138H138.376L134.459 11.6191H134.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.764 11.6191L138.68 49.138H138.528L134.611 11.6191H134.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.916 11.6191L138.833 49.138H138.68L134.764 11.6191H134.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.068 11.6191L138.985 49.138H138.833L134.916 11.6191H135.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.221 11.6191L139.137 49.138H138.985L135.068 11.6191H135.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.373 11.6191L139.29 49.138H139.137L135.221 11.6191H135.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.525 11.6191L139.442 49.138H139.29L135.373 11.6191H135.525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.678 11.6191L139.594 49.138H139.442L135.525 11.6191H135.678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.83 11.6191L139.747 49.138H139.594L135.678 11.6191H135.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.982 11.6191L139.899 49.138H139.747L135.83 11.6191H135.982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.135 11.6191L140.051 49.138H139.899L135.982 11.6191H136.135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.287 11.6191L140.204 49.138H140.052L136.135 11.6191H136.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.439 11.6191L140.356 49.138H140.204L136.287 11.6191H136.439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.59 11.6191L140.506 49.138H140.354L136.438 11.6191H136.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.742 11.6191L140.659 49.138H140.507L136.59 11.6191H136.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.895 11.6191L140.812 49.138H140.659L136.742 11.6191H136.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.049 11.6191L140.965 49.138H140.813L136.896 11.6191H137.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.201 11.6191L141.118 49.138H140.966L137.049 11.6191H137.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.351 11.6191L141.268 49.138H141.116L137.199 11.6191H137.351Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.504 11.6191L141.421 49.138H141.268L137.352 11.6191H137.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.656 11.6191L141.573 49.138H141.421L137.504 11.6191H137.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.808 11.6191L141.725 49.138H141.573L137.656 11.6191H137.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.961 11.6191L141.878 49.138H141.725L137.809 11.6191H137.961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.113 11.6191L142.03 49.138H141.878L137.961 11.6191H138.113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.266 11.6191L142.182 49.138H142.03L138.113 11.6191H138.266Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.418 11.6191L142.335 49.138H142.182L138.266 11.6191H138.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.57 11.6191L142.487 49.138H142.334L138.418 11.6191H138.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.723 11.6191L142.639 49.138H142.487L138.57 11.6191H138.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.875 11.6191L142.792 49.138H142.639L138.723 11.6191H138.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.027 11.6191L142.944 49.138H142.792L138.875 11.6191H139.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.18 11.6191L143.096 49.138H142.944L139.027 11.6191H139.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.332 11.6191L143.249 49.138H143.096L139.18 11.6191H139.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.484 11.6191L143.401 49.138H143.249L139.332 11.6191H139.484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.637 11.6191L143.553 49.138H143.401L139.484 11.6191H139.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.789 11.6191L143.706 49.138H143.553L139.637 11.6191H139.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.942 11.6191L143.858 49.138H143.706L139.789 11.6191H139.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.094 11.6191L144.01 49.138H143.858L139.941 11.6191H140.094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.246 11.6191L144.163 49.138H144.01L140.094 11.6191H140.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.398 11.6191L144.315 49.138H144.163L140.246 11.6191H140.398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.551 11.6191L144.467 49.138H144.315L140.398 11.6191H140.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.703 11.6191L144.62 49.138H144.468L140.551 11.6191H140.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.855 11.6191L144.772 49.138H144.62L140.703 11.6191H140.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.008 11.6191L144.924 49.138H144.772L140.855 11.6191H141.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.16 11.6191L145.077 49.138H144.925L141.008 11.6191H141.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.31 11.6191L145.227 49.138H145.075L141.158 11.6191H141.31Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.463 11.6191L145.38 49.138H145.227L141.311 11.6191H141.463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.616 11.6191L145.532 49.138H145.38L141.463 11.6191H141.616Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.769 11.6191L145.686 49.138H145.534L141.617 11.6191H141.769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.922 11.6191L145.838 49.138H145.686L141.77 11.6191H141.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.072 11.6191L145.989 49.138H145.837L141.92 11.6191H142.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.224 11.6191L146.141 49.138H145.989L142.072 11.6191H142.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.377 11.6191L146.294 49.138H146.141L142.225 11.6191H142.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.529 11.6191L146.446 49.138H146.294L142.377 11.6191H142.529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.682 11.6191L146.598 49.138H146.446L142.529 11.6191H142.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.834 11.6191L146.745 49.0859V49.138H146.598L142.682 11.6191H142.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.986 11.6191L146.745 47.6275V49.0859L142.834 11.6191H142.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.139 11.6191L146.745 46.1685V47.6275L142.986 11.6191H143.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.291 11.6191L146.745 44.7101V46.1685L143.139 11.6191H143.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.443 11.6191L146.745 43.2512V44.7101L143.291 11.6191H143.443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.745 43.2512L143.443 11.6191H146.745V43.2512Z",
    fill: "white"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.578 13.0376L123.264 19.6088L126.876 19.2392L129.341 42.855L129.127 42.877C127.268 43.0675 125.57 41.6997 125.378 39.8604L125.356 39.6502L118.725 40.3829L118.747 40.5931C119.317 46.0588 124.297 50.0651 129.818 49.5003L133.351 49.1388L129.778 14.9112L122.578 13.0381V13.0376Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_512_1104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 118,
    y: 13,
    width: 16,
    height: 37
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.578 13.0376L123.264 19.6088L126.876 19.2392L129.341 42.855L129.127 42.877C127.268 43.0675 125.57 41.6997 125.378 39.8604L125.356 39.6502L118.725 40.3829L118.747 40.5931C119.317 46.0588 124.297 50.0651 129.818 49.5003L133.351 49.1388L129.778 14.9112L122.578 13.0381V13.0376Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_512_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.725 40.3823L119.735 50.0651H118.725V40.3823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 38.9551L119.884 50.0651H119.735L118.725 40.3824V38.9551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 37.5273L120.033 50.0653H119.884L118.725 38.9552V37.5273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 36.0991L120.183 50.0649H120.033L118.725 37.527V36.0991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 34.6714L120.332 50.065H120.183L118.725 36.0992V34.6714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 33.2441L120.481 50.0651H120.332L118.725 34.6715V33.2441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 31.8164L120.63 50.0652H120.481L118.725 33.2443V31.8164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 30.3887L120.779 50.0653H120.63L118.725 31.8165V30.3887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 28.9609L120.928 50.0649H120.779L118.725 30.3882V28.9609Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 27.5332L121.077 50.065H120.928L118.725 28.9611V27.5332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 26.1055L121.226 50.0651H121.077L118.725 27.5333V26.1055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 24.6777L121.375 50.0652H121.226L118.725 26.1056V24.6777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 23.2505L121.524 50.0653H121.375L118.725 24.6778V23.2505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 21.8223L121.673 50.0649H121.524L118.725 23.2501V21.8223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 20.3945L121.822 50.065H121.673L118.725 21.8224V20.3945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 18.9668L121.971 50.0651H121.822L118.725 20.3946V18.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 17.5396L122.12 50.0652H121.971L118.725 18.9669V17.5396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 16.1118L122.269 50.0653H122.12L118.725 17.5397V16.1118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 14.6836L122.418 50.0649H122.269L118.725 16.1114V14.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 13.2563L122.567 50.065H122.418L118.725 14.6837V13.2563Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.851 13.0376L122.717 50.0651H122.567L118.725 13.2564V13.0376H118.851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.001 13.0376L122.866 50.0651H122.717L118.852 13.0376H119.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.149 13.0376L123.014 50.0651H122.865L119 13.0376H119.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.297 13.0376L123.163 50.0651H123.014L119.148 13.0376H119.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.448 13.0376L123.313 50.0651H123.164L119.299 13.0376H119.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.596 13.0376L123.462 50.0651H123.313L119.447 13.0376H119.596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.745 13.0376L123.61 50.0651H123.461L119.596 13.0376H119.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.895 13.0376L123.76 50.0651H123.611L119.746 13.0376H119.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.044 13.0376L123.909 50.0651H123.76L119.895 13.0376H120.044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.192 13.0376L124.058 50.0651H123.909L120.043 13.0376H120.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.341 13.0376L124.206 50.0651H124.057L120.191 13.0376H120.341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.491 13.0376L124.356 50.0651H124.207L120.342 13.0376H120.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.639 13.0376L124.504 50.0651H124.356L120.49 13.0376H120.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.788 13.0376L124.653 50.0651H124.504L120.639 13.0376H120.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.938 13.0376L124.803 50.0651H124.654L120.789 13.0376H120.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.086 13.0376L124.952 50.0651H124.803L120.938 13.0376H121.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.235 13.0376L125.101 50.0651H124.951L121.086 13.0376H121.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.385 13.0376L125.251 50.0651H125.102L121.236 13.0376H121.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.534 13.0376L125.4 50.0651H125.251L121.385 13.0376H121.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.682 13.0376L125.547 50.0651H125.398L121.533 13.0376H121.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.833 13.0376L125.698 50.0651H125.549L121.684 13.0376H121.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.981 13.0376L125.846 50.0651H125.697L121.832 13.0376H121.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.129 13.0376L125.995 50.0651H125.846L121.98 13.0376H122.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28 13.0376L126.145 50.0651H125.996L122.131 13.0376H122.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.428 13.0376L126.294 50.0651H126.145L122.279 13.0376H122.428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.577 13.0376L126.443 50.0651H126.293L122.428 13.0376H122.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.725 13.0376L126.591 50.0651H126.442L122.576 13.0376H122.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.876 13.0376L126.741 50.0651H126.592L122.727 13.0376H122.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.024 13.0376L126.889 50.0651H126.74L122.875 13.0376H123.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.172 13.0376L127.038 50.0651H126.889L123.023 13.0376H123.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.323 13.0376L127.188 50.0651H127.039L123.174 13.0376H123.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.471 13.0376L127.337 50.0651H127.188L123.322 13.0376H123.471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.62 13.0376L127.485 50.0651H127.336L123.471 13.0376H123.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.77 13.0376L127.636 50.0651H127.486L123.621 13.0376H123.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.919 13.0376L127.784 50.0651H127.635L123.77 13.0376H123.919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.067 13.0376L127.933 50.0651H127.784L123.918 13.0376H124.067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.217 13.0376L128.083 50.0651H127.934L124.068 13.0376H124.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.366 13.0376L128.231 50.0651H128.082L124.217 13.0376H124.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.514 13.0376L128.379 50.0651H128.231L124.365 13.0376H124.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.665 13.0376L128.53 50.0651H128.381L124.516 13.0376H124.665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.813 13.0376L128.678 50.0651H128.529L124.664 13.0376H124.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.961 13.0376L128.827 50.0651H128.678L124.812 13.0376H124.961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.11 13.0376L128.976 50.0651H128.827L124.961 13.0376H125.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.261 13.0376L129.126 50.0651H128.977L125.111 13.0376H125.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.409 13.0376L129.274 50.0651H129.125L125.26 13.0376H125.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.557 13.0376L129.422 50.0651H129.273L125.408 13.0376H125.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.708 13.0376L129.573 50.0651H129.424L125.559 13.0376H125.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.856 13.0376L129.721 50.0651H129.572L125.707 13.0376H125.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.004 13.0376L129.87 50.0651H129.721L125.855 13.0376H126.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.155 13.0376L130.02 50.0651H129.871L126.006 13.0376H126.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.303 13.0376L130.169 50.0651H130.02L126.154 13.0376H126.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.452 13.0376L130.318 50.0651H130.169L126.303 13.0376H126.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.601 13.0376L130.466 50.0651H130.317L126.451 13.0376H126.601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.751 13.0376L130.616 50.0651H130.467L126.602 13.0376H126.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.899 13.0376L130.764 50.0651H130.615L126.75 13.0376H126.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.047 13.0376L130.913 50.0651H130.764L126.898 13.0376H127.047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.198 13.0376L131.063 50.0651H130.914L127.049 13.0376H127.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.346 13.0376L131.212 50.0651H131.063L127.197 13.0376H127.346Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.495 13.0376L131.36 50.0651H131.211L127.346 13.0376H127.495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.645 13.0376L131.511 50.0651H131.362L127.496 13.0376H127.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.794 13.0376L131.659 50.0651H131.51L127.645 13.0376H127.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.942 13.0376L131.807 50.0651H131.658L127.793 13.0376H127.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.092 13.0376L131.958 50.0651H131.809L127.943 13.0376H128.092Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.241 13.0376L132.106 50.0651H131.957L128.092 13.0376H128.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.389 13.0376L132.254 50.0651H132.106L128.24 13.0376H128.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.54 13.0376L132.405 50.0651H132.256L128.391 13.0376H128.54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.688 13.0376L132.553 50.0651H132.404L128.539 13.0376H128.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.836 13.0376L132.702 50.0651H132.553L128.688 13.0376H128.836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.985 13.0376L132.851 50.0651H132.702L128.836 13.0376H128.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.135 13.0376L133.001 50.0651H132.852L128.986 13.0376H129.135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.284 13.0376L133.149 50.0651H133L129.135 13.0376H129.284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.432 13.0376L133.297 50.0651H133.148L129.283 13.0376H129.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.583 13.0376L133.351 49.1382V50.0651H133.299L129.434 13.0376H129.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.351 49.1382L129.582 13.0376H133.351V49.1382Z",
    fill: "white"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M136.437 11.6191L129.51 12.3282H129.506L122.578 13.0373L129.778 14.9104L136.437 11.6191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_512_1104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 122,
    y: 11,
    width: 15,
    height: 4
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.437 11.6191L129.51 12.3282H129.506L122.578 13.0373L129.778 14.9104L136.437 11.6191Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_512_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.578 13.0371L122.774 14.9102H122.578V13.0371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.582 11.6191L122.926 14.9104H122.774L122.578 13.0373V11.6191H122.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.734 11.6191L123.078 14.9104H122.925L122.582 11.6191H122.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.887 11.6191L123.23 14.9104H123.078L122.734 11.6191H122.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.039 11.6191L123.382 14.9104H123.23L122.887 11.6191H123.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.191 11.6191L123.535 14.9104H123.383L123.039 11.6191H123.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.344 11.6191L123.687 14.9104H123.535L123.191 11.6191H123.344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.496 11.6191L123.839 14.9104H123.687L123.344 11.6191H123.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.648 11.6191L123.992 14.9104H123.84L123.496 11.6191H123.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.801 11.6191L124.144 14.9104H123.992L123.648 11.6191H123.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.953 11.6191L124.296 14.9104H124.144L123.801 11.6191H123.953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.105 11.6191L124.449 14.9104H124.297L123.953 11.6191H124.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.258 11.6191L124.601 14.9104H124.449L124.105 11.6191H124.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.41 11.6191L124.754 14.9104H124.601L124.258 11.6191H124.41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.562 11.6191L124.906 14.9104H124.754L124.41 11.6191H124.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.713 11.6191L125.057 14.9104H124.905L124.561 11.6191H124.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.865 11.6191L125.209 14.9104H125.057L124.713 11.6191H124.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.017 11.6191L125.361 14.9104H125.209L124.865 11.6191H125.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.17 11.6191L125.514 14.9104H125.362L125.018 11.6191H125.17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.323 11.6191L125.666 14.9104H125.514L125.17 11.6191H125.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.474 11.6191L125.818 14.9104H125.666L125.322 11.6191H125.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.627 11.6191L125.97 14.9104H125.818L125.475 11.6191H125.627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.779 11.6191L126.123 14.9104H125.97L125.627 11.6191H125.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.932 11.6191L126.275 14.9104H126.123L125.779 11.6191H125.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.084 11.6191L126.427 14.9104H126.275L125.932 11.6191H126.084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.236 11.6191L126.58 14.9104H126.427L126.084 11.6191H126.236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.389 11.6191L126.732 14.9104H126.58L126.236 11.6191H126.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.541 11.6191L126.884 14.9104H126.732L126.389 11.6191H126.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.693 11.6191L127.037 14.9104H126.884L126.541 11.6191H126.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.846 11.6191L127.189 14.9104H127.037L126.693 11.6191H126.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.998 11.6191L127.341 14.9104H127.189L126.846 11.6191H126.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.15 11.6191L127.494 14.9104H127.342L126.998 11.6191H127.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.303 11.6191L127.647 14.9104H127.494L127.15 11.6191H127.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.455 11.6191L127.799 14.9104H127.647L127.303 11.6191H127.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.607 11.6191L127.951 14.9104H127.799L127.455 11.6191H127.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.76 11.6191L128.104 14.9104H127.951L127.607 11.6191H127.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.91 11.6191L128.254 14.9104H128.102L127.758 11.6191H127.91Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.062 11.6191L128.406 14.9104H128.254L127.91 11.6191H128.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.215 11.6191L128.559 14.9104H128.407L128.062 11.6191H128.215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.369 11.6191L128.712 14.9104H128.56L128.217 11.6191H128.369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.521 11.6191L128.865 14.9104H128.713L128.369 11.6191H128.521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.672 11.6191L129.015 14.9104H128.863L128.52 11.6191H128.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.824 11.6191L129.168 14.9104H129.015L128.672 11.6191H128.824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.976 11.6191L129.32 14.9104H129.168L128.824 11.6191H128.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.129 11.6191L129.472 14.9104H129.32L128.977 11.6191H129.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.281 11.6191L129.625 14.9104H129.472L129.129 11.6191H129.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.433 11.6191L129.777 14.9104H129.625L129.281 11.6191H129.433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.586 11.6191L129.929 14.9104H129.777L129.434 11.6191H129.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.738 11.6191L130.082 14.9104H129.929L129.586 11.6191H129.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.89 11.6191L130.234 14.9104H130.082L129.738 11.6191H129.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.043 11.6191L130.386 14.9104H130.234L129.891 11.6191H130.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.195 11.6191L130.539 14.9104H130.386L130.043 11.6191H130.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.348 11.6191L130.692 14.9104H130.539L130.195 11.6191H130.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.5 11.6191L130.844 14.9104H130.692L130.348 11.6191H130.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.652 11.6191L130.996 14.9104H130.844L130.5 11.6191H130.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.805 11.6191L131.149 14.9104H130.996L130.652 11.6191H130.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.957 11.6191L131.301 14.9104H131.149L130.805 11.6191H130.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.109 11.6191L131.453 14.9104H131.3L130.957 11.6191H131.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.262 11.6191L131.605 14.9104H131.453L131.109 11.6191H131.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.414 11.6191L131.757 14.9104H131.605L131.262 11.6191H131.414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.566 11.6191L131.91 14.9104H131.758L131.414 11.6191H131.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.719 11.6191L132.062 14.9104H131.91L131.566 11.6191H131.719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.869 11.6191L132.212 14.9104H132.06L131.717 11.6191H131.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.021 11.6191L132.365 14.9104H132.213L131.869 11.6191H132.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.174 11.6191L132.517 14.9104H132.365L132.021 11.6191H132.174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.326 11.6191L132.67 14.9104H132.517L132.174 11.6191H132.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.478 11.6191L132.822 14.9104H132.67L132.326 11.6191H132.478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.631 11.6191L132.974 14.9104H132.822L132.479 11.6191H132.631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.783 11.6191L133.127 14.9104H132.974L132.631 11.6191H132.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.935 11.6191L133.279 14.9104H133.127L132.783 11.6191H132.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.088 11.6191L133.432 14.9104H133.279L132.936 11.6191H133.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.24 11.6191L133.584 14.9104H133.432L133.088 11.6191H133.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.392 11.6191L133.736 14.9104H133.584L133.24 11.6191H133.392Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.545 11.6191L133.889 14.9104H133.737L133.393 11.6191H133.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.697 11.6191L134.041 14.9104H133.889L133.545 11.6191H133.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.85 11.6191L134.194 14.9104H134.041L133.697 11.6191H133.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.002 11.6191L134.345 14.9104H134.193L133.85 11.6191H134.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.154 11.6191L134.498 14.9104H134.345L134.002 11.6191H134.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.307 11.6191L134.65 14.9104H134.498L134.154 11.6191H134.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.459 11.6191L134.802 14.9104H134.65L134.307 11.6191H134.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.611 11.6191L134.955 14.9104H134.802L134.459 11.6191H134.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.764 11.6191L135.107 14.9104H134.955L134.611 11.6191H134.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.916 11.6191L135.259 14.9104H135.107L134.764 11.6191H134.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.066 11.6191L135.41 14.9104H135.258L134.914 11.6191H135.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.219 11.6191L135.562 14.9104H135.41L135.066 11.6191H135.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.371 11.6191L135.714 14.9104H135.562L135.219 11.6191H135.371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.523 11.6191L135.867 14.9104H135.715L135.371 11.6191H135.523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.676 11.6191L136.019 14.9104H135.867L135.523 11.6191H135.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.828 11.6191L136.172 14.9104H136.019L135.676 11.6191H135.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.98 11.6191L136.324 14.9104H136.172L135.828 11.6191H135.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.133 11.6191L136.437 14.536V14.9104H136.324L135.98 11.6191H136.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.285 11.6191L136.437 13.0776V14.536L136.133 11.6191H136.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.437 13.0776L136.285 11.6191H136.437V13.0776Z",
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M115.689 43.4912C115.689 43.4912 119.622 54.1389 132.752 51.0649C143.938 48.4458 147.106 52.0116 147.106 52.0116C147.106 52.0116 141.51 49.2659 132.752 52.6746C123.993 56.0828 115.154 52.9149 115.689 43.4912Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_512_1104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 115,
    y: 43,
    width: 33,
    height: 12
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M115.689 43.4912C115.689 43.4912 119.622 54.1389 132.752 51.0649C143.938 48.4458 147.106 52.0116 147.106 52.0116C147.106 52.0116 141.51 49.2659 132.752 52.6746C123.993 56.0828 115.154 52.9149 115.689 43.4912Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_512_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.008 43.4912H115.666V56.0828H116.008V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.35 43.4912H116.008V56.0828H116.35V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.691 43.4912H116.35V56.0828H116.691V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.033 43.4912H116.691V56.0828H117.033V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.375 43.4912H117.033V56.0828H117.375V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.717 43.4912H117.375V56.0828H117.717V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.059 43.4912H117.717V56.0828H118.059V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.4 43.4912H118.059V56.0828H118.4V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.74 43.4912H118.398V56.0828H118.74V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.082 43.4912H118.74V56.0828H119.082V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.424 43.4912H119.082V56.0828H119.424V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.766 43.4912H119.424V56.0828H119.766V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.109 43.4912H119.768V56.0828H120.109V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.451 43.4912H120.109V56.0828H120.451V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.791 43.4912H120.449V56.0828H120.791V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.133 43.4912H120.791V56.0828H121.133V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.475 43.4912H121.133V56.0828H121.475V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.816 43.4912H121.475V56.0828H121.816V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.158 43.4912H121.816V56.0828H122.158V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5 43.4912H122.158V56.0828H122.5V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.842 43.4912H122.5V56.0828H122.842V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.184 43.4912H122.842V56.0828H123.184V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.525 43.4912H123.184V56.0828H123.525V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.867 43.4912H123.525V56.0828H123.867V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.209 43.4912H123.867V56.0828H124.209V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.551 43.4912H124.209V56.0828H124.551V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.893 43.4912H124.551V56.0828H124.893V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.234 43.4912H124.893V56.0828H125.234V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.576 43.4912H125.234V56.0828H125.576V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.918 43.4912H125.576V56.0828H125.918V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.26 43.4912H125.918V56.0828H126.26V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.602 43.4912H126.26V56.0828H126.602V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.943 43.4912H126.602V56.0828H126.943V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.285 43.4912H126.943V56.0828H127.285V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.627 43.4912H127.285V56.0828H127.627V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.969 43.4912H127.627V56.0828H127.969V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.311 43.4912H127.969V56.0828H128.311V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.652 43.4912H128.311V56.0828H128.652V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.994 43.4912H128.652V56.0828H128.994V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.336 43.4912H128.994V56.0828H129.336V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.678 43.4912H129.336V56.0828H129.678V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.02 43.4912H129.678V56.0828H130.02V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.359 43.4912H130.018V56.0828H130.359V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.701 43.4912H130.359V56.0828H130.701V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.043 43.4912H130.701V56.0828H131.043V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.385 43.4912H131.043V56.0828H131.385V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.727 43.4912H131.385V56.0828H131.727V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.07 43.4912H131.729V56.0828H132.07V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.41 43.4912H132.068V56.0828H132.41V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.752 43.4912H132.41V56.0828H132.752V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.094 43.4912H132.752V56.0828H133.094V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.436 43.4912H133.094V56.0828H133.436V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.777 43.4912H133.436V56.0828H133.777V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.119 43.4912H133.777V56.0828H134.119V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.461 43.4912H134.119V56.0828H134.461V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.803 43.4912H134.461V56.0828H134.803V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.145 43.4912H134.803V56.0828H135.145V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.486 43.4912H135.145V56.0828H135.486V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.828 43.4912H135.486V56.0828H135.828V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.17 43.4912H135.828V56.0828H136.17V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.512 43.4912H136.17V56.0828H136.512V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.854 43.4912H136.512V56.0828H136.854V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.195 43.4912H136.854V56.0828H137.195V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.537 43.4912H137.195V56.0828H137.537V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.879 43.4912H137.537V56.0828H137.879V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.221 43.4912H137.879V56.0828H138.221V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.563 43.4912H138.221V56.0828H138.563V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.904 43.4912H138.562V56.0828H138.904V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.246 43.4912H138.904V56.0828H139.246V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.588 43.4912H139.246V56.0828H139.588V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.93 43.4912H139.588V56.0828H139.93V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.272 43.4912H139.93V56.0828H140.272V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.613 43.4912H140.271V56.0828H140.613V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.955 43.4912H140.613V56.0828H140.955V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.297 43.4912H140.955V56.0828H141.297V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.639 43.4912H141.297V56.0828H141.639V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.979 43.4912H141.637V56.0828H141.979V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.32 43.4912H141.979V56.0828H142.32V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.662 43.4912H142.32V56.0828H142.662V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.004 43.4912H142.662V56.0828H143.004V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.346 43.4912H143.004V56.0828H143.346V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.688 43.4912H143.346V56.0828H143.688V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.029 43.4912H143.688V56.0828H144.029V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.371 43.4912H144.029V56.0828H144.371V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.713 43.4912H144.371V56.0828H144.713V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.055 43.4912H144.713V56.0828H145.055V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.397 43.4912H145.055V56.0828H145.397V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.738 43.4912H145.396V56.0828H145.738V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08 43.4912H145.738V56.0828H146.08V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.422 43.4912H146.08V56.0828H146.422V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.764 43.4912H146.422V56.0828H146.764V43.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.106 43.4912H146.764V56.0828H147.106V43.4912Z",
    fill: "white"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M116.107 50.6396C116.107 50.6396 118.406 56.8638 126.081 55.0669C132.62 53.5356 134.472 55.6205 134.472 55.6205C134.472 55.6205 131.201 54.0156 126.081 56.0078C120.961 57.9999 115.795 56.1483 116.107 50.6396Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_512_1104",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 50,
    width: 19,
    height: 7
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.107 50.6396C116.107 50.6396 118.406 56.8638 126.081 55.0669C132.62 53.5356 134.472 55.6205 134.472 55.6205C134.472 55.6205 131.201 54.0156 126.081 56.0078C120.961 57.9999 115.795 56.1483 116.107 50.6396Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_512_1104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.294 50.6396H116.094V57.9999H116.294V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.493 50.6396H116.293V57.9999H116.493V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.694 50.6396H116.494V57.9999H116.694V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.893 50.6396H116.693V57.9999H116.893V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.092 50.6396H116.893V57.9999H117.092V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.294 50.6396H117.094V57.9999H117.294V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.493 50.6396H117.293V57.9999H117.493V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.692 50.6396H117.492V57.9999H117.692V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.891 50.6396H117.691V57.9999H117.891V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.092 50.6396H117.893V57.9999H118.092V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.292 50.6396H118.092V57.9999H118.292V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.491 50.6396H118.291V57.9999H118.491V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.69 50.6396H118.49V57.9999H118.69V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.891 50.6396H118.691V57.9999H118.891V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.091 50.6396H118.891V57.9999H119.091V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.29 50.6396H119.09V57.9999H119.29V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.491 50.6396H119.291V57.9999H119.491V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.69 50.6396H119.49V57.9999H119.69V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.889 50.6396H119.689V57.9999H119.889V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.089 50.6396H119.889V57.9999H120.089V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.29 50.6396H120.09V57.9999H120.29V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.489 50.6396H120.289V57.9999H120.489V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.688 50.6396H120.488V57.9999H120.688V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.887 50.6396H120.688V57.9999H120.887V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.089 50.6396H120.889V57.9999H121.089V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.288 50.6396H121.088V57.9999H121.288V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.489 50.6396H121.289V57.9999H121.489V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.688 50.6396H121.488V57.9999H121.688V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.887 50.6396H121.688V57.9999H121.887V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.087 50.6396H121.887V57.9999H122.087V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.288 50.6396H122.088V57.9999H122.288V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.487 50.6396H122.287V57.9999H122.487V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.686 50.6396H122.486V57.9999H122.686V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.885 50.6396H122.686V57.9999H122.885V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.087 50.6396H122.887V57.9999H123.087V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.286 50.6396H123.086V57.9999H123.286V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.485 50.6396H123.285V57.9999H123.485V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.686 50.6396H123.486V57.9999H123.686V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.885 50.6396H123.686V57.9999H123.885V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.085 50.6396H123.885V57.9999H124.085V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.284 50.6396H124.084V57.9999H124.284V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.485 50.6396H124.285V57.9999H124.485V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.684 50.6396H124.484V57.9999H124.684V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.883 50.6396H124.684V57.9999H124.883V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.083 50.6396H124.883V57.9999H125.083V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.284 50.6396H125.084V57.9999H125.284V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.483 50.6396H125.283V57.9999H125.483V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.682 50.6396H125.482V57.9999H125.682V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.883 50.6396H125.684V57.9999H125.883V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.083 50.6396H125.883V57.9999H126.083V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.282 50.6396H126.082V57.9999H126.282V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.481 50.6396H126.281V57.9999H126.481V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.682 50.6396H126.482V57.9999H126.682V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.882 50.6396H126.682V57.9999H126.882V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.081 50.6396H126.881V57.9999H127.081V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.28 50.6396H127.08V57.9999H127.28V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.481 50.6396H127.281V57.9999H127.481V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.68 50.6396H127.48V57.9999H127.68V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.88 50.6396H127.68V57.9999H127.88V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.081 50.6396H127.881V57.9999H128.081V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.28 50.6396H128.08V57.9999H128.28V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.479 50.6396H128.279V57.9999H128.479V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.68 50.6396H128.48V57.9999H128.68V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88 50.6396H128.68V57.9999H128.88V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.079 50.6396H128.879V57.9999H129.079V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.278 50.6396H129.078V57.9999H129.278V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.479 50.6396H129.279V57.9999H129.479V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.678 50.6396H129.479V57.9999H129.678V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.878 50.6396H129.678V57.9999H129.878V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.077 50.6396H129.877V57.9999H130.077V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.278 50.6396H130.078V57.9999H130.278V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.477 50.6396H130.277V57.9999H130.477V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.676 50.6396H130.477V57.9999H130.676V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.878 50.6396H130.678V57.9999H130.878V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.077 50.6396H130.877V57.9999H131.077V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.276 50.6396H131.076V57.9999H131.276V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.475 50.6396H131.275V57.9999H131.475V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.676 50.6396H131.477V57.9999H131.676V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.876 50.6396H131.676V57.9999H131.876V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.075 50.6396H131.875V57.9999H132.075V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.274 50.6396H132.074V57.9999H132.274V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.475 50.6396H132.275V57.9999H132.475V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.675 50.6396H132.475V57.9999H132.675V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.874 50.6396H132.674V57.9999H132.874V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.075 50.6396H132.875V57.9999H133.075V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.274 50.6396H133.074V57.9999H133.274V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.473 50.6396H133.273V57.9999H133.473V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.675 50.6396H133.475V57.9999H133.675V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.874 50.6396H133.674V57.9999H133.874V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.073 50.6396H133.873V57.9999H134.073V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.272 50.6396H134.072V57.9999H134.272V50.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.473 50.6396H134.273V57.9999H134.473V50.6396Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner7);
export default __webpack_public_path__ + "static/media/partner7.c3f973f5a5d759a878e1eae294baba66.svg";
export { ForwardRef as ReactComponent };